import styled from 'styled-components';

import { Box, Text } from '@gympass/yoga';

import { patientsModalWidth } from 'modals/ChatListModal/styles';

export const ChatListContainer = styled(Box)`
  height: 100%;
  position: relative;
  min-width: 364px;
  width: ${patientsModalWidth}px;

  @media screen and (max-width: 1024px) {
    width: 100%;
  }
`;

export const Container = styled(Box)`
  height: 100vh;
  overflow-y: clip;

  @media screen and (max-width: 1024px) {
    & > div:not(:first-child),
    & > aside {
      display: none;
    }

    ${ChatListContainer} {
      width: 100%;
    }
  }
`;

export const AllPatientsTitle = styled(Text.Medium)`
  margin-left: ${({ theme }) => theme.yoga.spacing.xlarge}px;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
`;
